import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import ReactTableGeneric from 'Components/ReactTableGeneric';
import { formatWtfNl, parseWtfNl } from '../utils/formatWtf';

const AfasDagdelenEditModal = ({ isOpen, dayRow, onClose, onSave }) => {
    const [shiftValues, setShiftValues] = useState({});
    const shifts = useMemo(() => dayRow?.shifts ?? [], [dayRow]);

    useEffect(() => {
        if (!isOpen || !dayRow?.shifts) {
            return;
        }

        const next = {};
        dayRow.shifts.forEach((shift) => {
            next[shift.id] = formatWtfNl(shift.wtf);
        });
        setShiftValues(next);
    }, [isOpen, dayRow]);

    const handleValueChange = useCallback((id, value) => {
        setShiftValues((prev) => ({ ...prev, [id]: value }));
    }, []);

    const columns = useMemo(
        () => [
            { accessorKey: 'datum', header: 'Datum' },
            { accessorKey: 'dagdeel', header: 'Dagdeel' },
            { accessorKey: 'dagType', header: 'Dagtype' },
            { accessorKey: 'soortWtf', header: 'Soort WTF' },
            {
                accessorKey: 'value',
                header: 'WTF',
                size: 90,
                cell: ({ row }) => (
                    <Input
                        id={`afas-dagdeel-wtf-${row.original.id}`}
                        type="text"
                        className="form-control form-control-sm afas-input-modal"
                        value={row.original.value}
                        onChange={(event) =>
                            handleValueChange(row.original.id, event.target.value)
                        }
                    />
                ),
            },
        ],
        [handleValueChange],
    );

    const tableData = useMemo(
        () =>
            shifts.map((shift) => ({
                ...shift,
                datum: shift.datum || dayRow?.datum || '',
                value: shiftValues[shift.id] ?? '',
            })),
        [shifts, shiftValues, dayRow],
    );

    const handleSave = () => {
        const updates = shifts.map((shift) => ({
            id: shift.id,
            dagdeel: shift.dagdeel,
            wtfValue: parseWtfNl(shiftValues[shift.id]),
        }));
        onSave?.(updates);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            className="modal-dialog__over link-form afas-modal-style opmerking-modal-styling info-afas-modal-width"
        >
            <ModalHeader toggle={onClose}>wijzig WTF dagdeel</ModalHeader>
            <ModalBody>
                <div className="table-responsive rounded">
                    <ReactTableGeneric
                        data={tableData}
                        columns={columns}
                        filters={{ search: false, pagination: false, sorting: false }}
                        tableClassName="mb-0 table table-sm table-hover table-borderless align-middle"
                        count={tableData.length}
                    />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="primary"
                    outline
                    onClick={onClose}
                    className="btn-outline-primary-blue btn-color-style footer--coordinator-planboard__btn"
                >
                    Annuleren
                </Button>
                <Button
                    color="primary"
                    outline
                    onClick={handleSave}
                    className="btn-outline-primary-blue btn-color-style footer--coordinator-planboard__btn ms-1"
                >
                    Opslaan
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AfasDagdelenEditModal;